import {
    apiRequest,
    ListUser,
    UpdateDeparture,
    UpdateArrival,
    UpdateReturn,
    ConfirmReturn
} from "../../../../../services/adapters/kepegawaian/mutasiPegawaiService"

class IndexRepository {

    fetchList = async (query, cancelToken) => {
        return await apiRequest("get", ListUser, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchUpdateDeparture = async (query, cancelToken) => {
        return await apiRequest("post", UpdateDeparture, {
            body: query
        }, true)
    }

    fetchUpdateArrival = async (query, cancelToken) => {
        return await apiRequest("post", UpdateArrival, {
            body: query
        }, true)
    }

    fetchUpdateReturn = async (query, cancelToken) => {
        return await apiRequest("post", UpdateReturn, {
            body: query
        }, true)
    }

    fetchConfirmReturn = async (query, cancelToken) => {
        return await apiRequest("post", ConfirmReturn, {
            body: query
        }, true)
    }

}

export default IndexRepository